export const containsFctwPattern = (str) => {
    // const regex = /fctw|f\d{2}/i;
    const regex = /fctw/i;
    return regex.test(str);
}
  